import { DOMAIN, PROJECTS, TENANT_ID } from "@/app/lib/enums";
import type { TenantType } from "@/types";

const normalizeHostname = (host: string): string => host.split(":")[0];

type TenantDomainConfig = Omit<TenantType, "domain"> & {
   frontendDomains: Array<{
      domain: DOMAIN;
      rootDomain?: DOMAIN;
   }>;
};

const TENANT_DOMAIN_CONFIGS: TenantDomainConfig[] = [
   {
      tenantId: TENANT_ID.KINGS_AND_ALLIES,
      rootDomain: DOMAIN.KINGS_AND_ALLIES,
      project: PROJECTS.KINGS_AND_ALLIES,
      frontendDomains: [
         { domain: DOMAIN.KINGS_AND_ALLIES_STAGING_FRONTEND },
         { domain: DOMAIN.KINGS_AND_ALLIES_PRODUCTION_FRONTEND },
         {
            domain: DOMAIN.KINGS_AND_ALLIES_LOCAL_FRONTEND,
            rootDomain: DOMAIN.KINGS_AND_ALLIES_LOCAL
         }
      ]
   },
   {
      tenantId: TENANT_ID.CRYPTOCURRENCY_MARKET,
      rootDomain: DOMAIN.CRYPTOCURRENCY_MARKET,
      project: PROJECTS.CRYPTOCURRENCY_MARKET,
      frontendDomains: [
         { domain: DOMAIN.CRYPTOCURRENCY_MARKET_FRONTEND },
         { domain: DOMAIN.CRYPTOCURRENCY_MARKET_STAGING_FRONTEND },
         { domain: DOMAIN.CREDIBLE_PRODUCTION_FRONTEND },
         { domain: DOMAIN.CREDIBLE_STAGING_FRONTEND },
         {
            domain: DOMAIN.CRYPTOCURRENCY_MARKET_LOCAL_FRONTEND,
            rootDomain: DOMAIN.CRYPTOCURRENCY_MARKET_LOCAL
         },
         { domain: DOMAIN.LOCAL_FRONTEND }
      ]
   }
];

export const getTenantFromDomain = (host: string): TenantType | null => {
   const domain = normalizeHostname(host) as DOMAIN;
   const tenantConfig = TENANT_DOMAIN_CONFIGS.find((config) =>
      config.frontendDomains.some(
         (frontendDomain) =>
            frontendDomain.domain === host || frontendDomain.domain === domain
      )
   );
   const frontendConfig = tenantConfig?.frontendDomains.find(
      (frontendDomain) =>
         frontendDomain.domain === host || frontendDomain.domain === domain
   );
   if (!tenantConfig) return null;
   return {
      tenantId: tenantConfig.tenantId,
      rootDomain: frontendConfig?.rootDomain ?? tenantConfig.rootDomain,
      project: tenantConfig.project,
      domain
   };
};

export const getTenantIdFromHost = (host: string | null): TENANT_ID | null =>
   getTenantFromDomain(host || "")?.tenantId ?? null;

export const getSharedCookieRootDomainFromHost = (host?: string | null): DOMAIN | null =>
   getTenantFromDomain(host || "")?.rootDomain ?? null;
